export default __webpack_public_path__ + "static/media/active-pessoa-fisica.50e7f731.svg";